import moment from 'moment';
import * as XLSX from 'xlsx';

export type TChartType = 'line' | 'pie' | 'bar' | 'heatmap' | 'custom';

export const downloadCsv = (
  chartType: TChartType,
  data: any[],
  fileName: string,
  isHourly?: boolean
) => {
  let dataToExport = [];
  if (chartType === 'line') {
    const dateList = data[0].data.map((item) => item[0]);
    const convertedData = dateList.map((item, index) => {
    const row = { 
      date: isHourly 
      ? moment(item).format('DD-MM-YYYY HH:mm')
      : moment(item).format('DD-MM-YYYY')
    };

      data.forEach((seriesItem) => {
        row[seriesItem.name] = seriesItem.data[index]?.[1] ?? '';
      });

      return row;
    });

    dataToExport = convertedData;
  } else if (chartType === 'heatmap') {
    const time = [
      '00:00',
      '01:00',
      '02:00',
      '03:00',
      '04:00',
      '05:00',
      '06:00',
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00'
    ];
    const convertedData = [];
    for (let i = 0; i < time.length; i++) {
      convertedData.push({
        time: time[i],
        monday: data.find((item) => item.name === 'monday')?.data?.[i],
        tuesday: data.find((item) => item.name === 'tuesday')?.data?.[i],
        wednesday: data.find((item) => item.name === 'wednesday')?.data?.[i],
        thursday: data.find((item) => item.name === 'thursday')?.data?.[i],
        friday: data.find((item) => item.name === 'friday')?.data?.[i],
        saturday: data.find((item) => item.name === 'saturday')?.data?.[i],
        sunday: data.find((item) => item.name === 'sunday')?.data?.[i]
      });
    }
    dataToExport = convertedData;
  } else if (chartType === 'bar') {
    const convertedData = data.map((item) => {
      const row = { category: item.name };
      item.data.forEach((element) => {
        row[element.x] = element.y;
      });
      return row;
    });
    dataToExport = convertedData;
  } else {
    dataToExport = data;
  }
  // Convert to worksheet
  const worksheet = XLSX.utils.json_to_sheet(dataToExport);
  const csvContent = XLSX.utils.sheet_to_csv(worksheet);
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute(
      'download',
      `${fileName.replace(/[^a-z0-9]/gi, '_').toLowerCase()}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
